<div  class="container-fluid padding-bottom-small bottom-padding">
  <div class="col-sm-11 center-block">

    <h1 tabindex="0" aria-label="Search for unicodes">Substance Lookup</h1>
    <div>
      <p>Copy Ingredients from source and paste them into the field below. Click "Find Match" to return a status of "Found" or "Not Found" for each ingredient.
        Any successful matches will provide an XML snippet.</p>
      <p>
        <span>Ingredient Name(s) -</span> Ingredients must be separated by a comma.
      </p>
    </div>
    <div tabindex="0" class="input-area" id="inputArea" #inputArea contenteditable="true" placeholder="Type/Paste Ingredient Names here"></div>
    <div class="py-2">
      <button class="color-white e-btn e-lib btn-primary" id="btn-find-match" type="button" (click)="findMatch()">
        <i class="fa-solid fa-bullseye"></i> Find Match
      </button>
      <button class="e-btn e-lib mx-2"  type="button" [disabled]="loading" id="btn-clear-text-field" (click)="clearText()">
        <i class="fa-solid fa-eraser text-primary"></i> Clear Text Field
      </button>
    </div>
    <div class="my-4" *ngIf="substanceLookup">
    
    <div class="py-4 result-container" >
        <h1 tabindex="0" aria-label="Substance Lookup Results" role="heading" aria-level="1">Substance Lookup Results</h1>
        <div>
            <div class="d-flex justify-content-between align-items-center">
              <span>Complete result log</span>
              <div class="d-flex flex-row gap-10">
                  <button class="btn btn-primary my-4" 
                  [disabled]="loading" id="btn-copy-result-log"
                  (click)="copy('copyLog')" *ngIf="!isCopying">
                  <i class="fa-solid fa-copy"></i> Copy Result Log
                </button>
                <button class="btn btn-primary my-4 mx-2" 
                  [disabled]="loading" id="btn-copy-xml"
                  (click)="copy('copyXMLEmbedded')" *ngIf="!isCopying && substanceLookup.xmlResult">
                  <i class="fa-solid fa-copy"></i> Copy XML
                </button>
              </div>
            </div>
            <div class="border py-4 px-2 max-height" id="copyLog">
              
              <div class="py-2">
                <strong>Generated by</strong>
                <div id="result-username">{{username}}</div>
              </div>
              <br>
              <div class="py-2">
                <strong>Processing Details</strong>
                <div id="result-process-date">Date: {{ substanceLookup.processDate | date:'M/d/yyyy h:mm:ss a'}}</div>
                <div id="result-total-number-of-ingredients">Total ingredients included: {{substanceLookup.totalNumberOfIngredients}}</div>
                <div id="result-total-number-of-ingredients-found">Total number substances found: {{substanceLookup.totalNumberOfIngredientsFound}}</div>
                <div id="result-total-number-of-ingredients-not-found">Total number substances not found: {{substanceLookup.totalNumberOfIngredientsNotFound}}</div>
              </div>
              <br>
              <div class="py-2">
                <strong>Results</strong>
                <div class="row mx-0">
                  <table class="table table-inner table-striped col-12">
                    <thead>
                      <tr>
                        <th>Status</th>
                        <th>Original Ingredient</th>
                        <th>Preferred Name (UNII Code)</th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of substanceLookup.substanceLookupResults; index as i" [id]="'tabel-row-' + i">
                        <td [id]="'item-status-' + i">
                          <span [style.color]="item.found ? 'Green' : 'red'">{{item.found ? 'Found' : 'Not Found'}}</span>
                        </td>
                        <td [id]="'item-search-term-' + i">{{ item.searchTerm }}</td>
                        <td [id]="'item-unii-code-' + i"><span>
                          <ng-container *ngIf="item.preferredName">{{ item.preferredName }} ({{ item.uniiCode }})</ng-container>
                        </span></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <br>
              <div class="py-2">
                <strong>Initial User Input</strong>
                <div id="result-user-input">{{substanceLookup.userInput}}</div>
              </div>
              <br>
              <div class="py-2" *ngIf="substanceLookup.xmlResult">
                <strong>XML Snippets:</strong>
                <pre  id="copyXMLEmbedded" lang="xml">{{formatXml(substanceLookup.xmlResult)}}</pre>
              </div>
            </div>
        </div>

        
      </div>
    </div>
    <div *ngIf="loading">
      <div id="loading"></div>
    </div>
  </div>
</div>

